export function downloadResource(uri) {
  var link = document.createElement('a');
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link.remove();
}
